import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import './BlockDetails.css'
import Footer from '../../components/Footer'

const BlogDetails = () => {
  const { slug } = useParams()
  const [blog, setBlog] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const cleanHTML = (text) => {
    if (!text) return "";

    return text
      .replace(/<(?!\/?(b|strong)\b)[^>]*>/gi, "") // keep <b>, <strong>
      .replace(/&nbsp;/g, " ");
  };

  useEffect(() => {
    if (!slug) return

    fetch(`${BASE_URL}blog/${slug}`)
      .then((res) => res.json())
      .then((data) => {
        console.log('API 👉', data)
        if (data.success && data.data) {
          setBlog(data.data)
        } else {
          setBlog(false)
        }
      })
      .catch(console.error)
  }, [slug])

  if (blog === null) {
    return <p style={{ textAlign: 'center' }}>Loading...</p>
  }

  if (blog === false) {
    return (
      <h2 style={{ textAlign: 'center', padding: '100px' }}>Blog not found ❌</h2>
    )
  }

  return (
    <div>
      <Link to='/blog' className='bd-back'> ← Back to All Articles
      </Link>
      <div className='bd-hero'>
        <img src={blog.image || '/default.jpg'} alt={blog.heading} />
        <div className='bd-hero-overlay'>
          <span className='bd-tag'>{blog.tag}</span>
          <h2 class="text-white blog-heading">{blog.heading}</h2>
          <div className='bd-meta'>
            <span>{blog.date}</span>
            <span>•</span>
            <span>{blog.author}</span>
          </div>
        </div>
      </div>
      <div className='bd-page'>
        <section className='bd-section'>
          <div className='bd-container'>
            <div className='bd-article'>
              <p
                className="gap-description"
                dangerouslySetInnerHTML={{ __html: blog.content1 }}
              ></p>
              {/* <p class="gap-description"
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(blog.content1),
                }}
              />
              <p class="gap-description"
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(blog.content2),
                }}
              /> */}
              <h4 class="text-black mt-4 mb-0">Conclusion</h4>
              <p class="gap-description"
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(blog.conclusion),
                }}
              />
            </div>
            <aside className='bd-sidebar'>
              <div className='bd-card'>
                <h3 class="text-white">Need Expert Guidance?</h3>
                <p>
                  Get personalized support from our ISO experts.
                </p>
                <Link to='/ContactUs' className='bd-btn'> Contact Us Today
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  )
}

export default BlogDetails
